'use client';

/**
 * @module
 * @category Component
 */

import { Divider, ImageWithFallback } from '@bomdisoft/components';
import { getLanguageFromLocale, Translation } from '@bomdisoft/translations';
import { PlaceOrderButton } from '@pieleaf/app/[lang]/orders/place-order-button';
import { ImageGrid } from '@pieleaf/shared/image-grid';
import s from '@pieleaf/shared/produce-dashboard/styles.module.css';
import { ProductsChips } from '@pieleaf/shared/products-chips';
import { produceMainImageAlt } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export type ProduceDashboardProps = {
  items: ImageGridItem[];
  products: PageProduct[];
  title: Translation;
  description: Translation;
  image: string;
};

export const ProduceDashboard = ({ items, products, title, description, image }: ProduceDashboardProps) => {
  const params = useParams();
  const currentLanguage = getLanguageFromLocale(params.lang as string);

  return (
    <div className={s.column}>
      <div className={s.row}>
        <div className={s.card}>
          <div className={s.cardMedia}>
            <ImageWithFallback alt={produceMainImageAlt[currentLanguage]} fill priority sizes='(max-width: 900px) 100vw, (max-width: 1500px) 400px, 540px' src={image} />
          </div>
          <div className={s.cardContent}>
            <h5 className={s.title}>{title[currentLanguage]}</h5>
            <p className={s.description}>{description[currentLanguage]}</p>
            <ProductsChips products={products} />
          </div>
          <Divider className={s.wideOnly} />
          <div className={`${s.cardActions} ${s.wideOnly}`}>
            <PlaceOrderButton className={s.placeOrderButton} />
          </div>
        </div>
        <ImageGrid items={items} />
      </div>
    </div>
  );
};
